export const capitalize = (word) => {
  return word[0].toUpperCase() + word.slice(1);
};

export const timeZones = [
  { id: 1, name: 'Eastern Daylight Time - (GMT-4)' },
  { id: 2, name: 'Central Daylight Time - (GMT-5)' },
  { id: 3, name: 'Mountain Daylight Time - (GMT-6)' },
  { id: 4, name: 'Mountain Standard Time - (GMT-7)' },
  { id: 5, name: 'Pacific Daylight Time - (GMT-7)' },
  { id: 6, name: 'Alaska Daylight Time - (GMT-8)' },
  { id: 7, name: 'Hawaii-Aleutian Standard Time - (GMT-10)' }
];

export const daysOrder = {
  Sunday: 1,
  Monday: 2,
  Tuesday: 3,
  Wednesday: 4,
  Thursday: 5,
  Friday: 6,
  Saturday: 7
};

export const BUSINESSHOURS = [
  {
    value: 1,
    label: '1 AM'
  },
  {
    value: 2,
    label: '2 AM'
  },
  {
    value: 3,
    label: '3 AM'
  },
  {
    value: 4,
    label: '4 AM'
  },
  {
    value: 5,
    label: '5 AM'
  },
  {
    value: 6,
    label: '6 AM'
  },
  {
    value: 7,
    label: '7 AM'
  },
  {
    value: 8,
    label: '8 AM'
  },
  {
    value: 9,
    label: '9 AM'
  },
  {
    value: 10,
    label: '10 AM'
  },
  {
    value: 11,
    label: '11 AM'
  },
  {
    value: 12,
    label: '12 PM'
  },
  {
    value: 13,
    label: '1 PM'
  },
  {
    value: 14,
    label: '2 PM'
  },
  {
    value: 15,
    label: '3 PM'
  },
  {
    value: 16,
    label: '4 PM'
  },
  {
    value: 17,
    label: '5 PM'
  },
  {
    value: 18,
    label: '6 PM'
  },
  {
    value: 19,
    label: '7 PM'
  },
  {
    value: 20,
    label: '8 PM'
  },
  {
    value: 21,
    label: '9 PM'
  },
  {
    value: 22,
    label: '10 PM'
  },
  {
    value: 23,
    label: '11 PM'
  },
  {
    value: 0,
    label: '12 AM'
  }
];

export const accountManagers = [
  {
    id: '0',
    full_name: 'All',
    email: null
  },
  {
    id: '3359678000000161021',
    full_name: 'Stefan Singer',
    email: 'stefan@adlersocial.com'
  },
  {
    id: '3359678000003451001',
    full_name: 'Robin Lincoln-Codjoe',
    email: 'robin@adlersocial.com'
  },
  {
    id: '3359678000046853103',
    full_name: 'Daniel Dominguez',
    email: null
  },
  {
    id: '3359678000214543004',
    full_name: 'Kristen Younce',
    email: null
  },
  {
    id: '3359678000235814001',
    full_name: 'Maryie Reyna',
    email: 'maryie@adlerlocal.com'
  },
  {
    id: '3359678000238709001',
    full_name: 'Manuel Rosa',
    email: 'manuel@adlerlocal.com'
  },
  {
    id: '3359678000239553001',
    full_name: 'Oscar Mota',
    email: 'oscar@adlerlocal.com'
  }
];

export const PLANS = [
  { PK: '0', text: 'All' },
  { PK: 'pro', text: 'Pro Plan' },
  { PK: 'plus', text: 'Plus Plan' },
  { PK: 'elite', text: 'Elite Plan' },
  { PK: 'starter', text: 'Starter Plan' }
];

export const MODULES = [
  { PK: '0', text: 'All' },
  { id: 'GBP', text: 'GBP' },
  { id: 'APP', text: 'APP' }
];

export const allowedEmails = [
  'stefan@adlersocial.com',
  'robin@adlersocial.com',
  'phillippa@adlersocial.com',
  'jose@adlersocial.com',
  'kristen@adlerlocal.com',
  'david@adlerlocal.com',
  'matthew@adlerlocal.com',
  'manuel@adlerlocal.com',
  'oscar@adlerlocal.com',
  'maryie@adlerlocal.com',
  'celenny@adlerlocal.com'
];
